import { Timestamp } from '@griply/types';

export const getCalendarEventDate = (
  date: Timestamp | null | undefined,
  allDay: boolean,
): string | undefined => {
  if (!date) {
    return undefined;
  }

  if (!allDay) {
    return date.toISOString();
  }

  // FullCalendar (timeZone 'local') marks all-day events at local midnight — reading UTC components lands a day early ahead of UTC.
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  ).toISOString();
};
